<ng-template #pushDeniedTpl>
    <div class="overlay push-denied-overlay" uppDataid="guesthome-push-denied">
        <upp-scrollable class="guest-panel-scroll" [scrollbar]="'none'">
            <div class="body">
                <ion-card>
                    <ion-icon color="warning" name="sad"></ion-icon>
                    <ion-card-title color="warning">
                        {{ tr('@notifications_denied_title') }}
                    </ion-card-title>
                    <ion-card-content>
                        {{ tr('@notifications_denied_reason1') }}
                    </ion-card-content>
                </ion-card>

                <p>
                    {{ tr('@notifications_denied_message') }}
                    <br/>
                    <span class="small">{{ tr('@notifications_denied_reason2') }}</span>
                </p>
            </div>
            <div class="list-spacer"></div>

            <div class="form-buttons">
                <ion-button
                    uppDataid="guestpushdenied-ok-button"
                    color="warning"
                    size="large"
                    expand="block"
                    (click)="OnClosePushDenied()"
                >
                    {{ tr('@ok') }}
                </ion-button>
            </div>
        </upp-scrollable>
    </div>
</ng-template>

<div class="guest-home" [class.mobile]="view.Mobile" *ngIf="place">
    <upp-scrollable *ngIf="Panel === 'MENU'" class="guest-home-scroll" [scrollbar]="'none'">
        <div class="lang-picker" [class.open]="ShowLangMenu">
            <button
                type="button"
                class="lang-chip"
                uppDataid="guesthome-lang-chip"
                (click)="OnToggleLangMenu()"
            >
                <ion-icon class="flag-box" [ngClass]="LanguageFlag(CurrentLanguage)"></ion-icon>
                <span>{{ CurrentLanguage }}</span>
                <ion-icon class="chevron" name="chevron-down-outline"></ion-icon>
            </button>
            <div class="lang-menu" *ngIf="ShowLangMenu" uppDataid="guesthome-lang-menu">
                <button *ngFor="let code of Languages; trackBy: LangTrack" [uppDataid]="'guesthome-lang-' + code"
                    type="button"
                    class="lang-option"
                    [class.active]="code === CurrentLanguage"
                    (click)="OnSelectLanguage(code)"
                >
                    <ion-icon class="flag-box" [ngClass]="LanguageFlag(code)"></ion-icon>
                    <span>{{ tr('@language_' + code) }}</span>
                </button>
            </div>
        </div>

        <div class="img-box" *ngIf="place.photo">
            <img class="place-photo" [src]="place.photo" alt="" />
            <ion-grid>
                <ion-row>
                    <ion-col *ngFor="let link of socialLinks; trackBy: SocialTrack" [class.disabled]="!HasPlaceLink(link)">
                        <ion-icon
                            *ngIf="link === 'homepage'"
                            uppDataid="guest-link-homepage"
                            name="home-outline"
                            (click)="OnPlaceLink(link)"
                        ></ion-icon>
                        <img
                            *ngIf="link !== 'homepage'"
                            [uppDataid]="'guest-link-' + link"
                            class="social-logo"
                            [src]="'assets/image/' + link + '-logo.png'"
                            alt=""
                            (click)="OnPlaceLink(link)"
                        />
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>

        <p class="welcome" *ngIf="place.description?.tr()">{{ place.description?.tr() }}</p>

        <ion-item class="title" lines="none">
            <ion-label>
                {{ place.name }}<br/>
                <span class="small">{{ tr('@place_welcome_message') }}</span>
            </ion-label>
        </ion-item>

        <ion-item class="option extras" *ngIf="HasPendingExtras" uppDataid="guesthome-extras-banner" lines="none">
            <ion-icon slot="start" color="warning" name="alert-circle-outline"></ion-icon>
            <ion-label>
                {{ tr('@place_option_applyextras') }}<br/>
                <span class="small" *ngIf="PendingExtrasPrice === null">{{ tr('@place_option_applyextras_depend') }}</span>
                <span class="small" *ngIf="PendingExtrasPrice !== null">{{ tr('@place_option_applyextras_price', [ PendingExtrasPrice, tr('@currency') ]) }}</span>
            </ion-label>
        </ion-item>

        <div class="options" *ngIf="OptionTiles.length > 0">
            <p class="options-hint">{{ tr('@place_options_hint') }}</p>
            <div class="option-grid">
                <button
                    type="button"
                    class="option-tile"
                    *ngFor="let tile of OptionTiles; trackBy: OptionTrack"
                    [uppDataid]="'guesthome-option-' + tile.opkey"
                    [ngClass]="{
                        'ok': tile.tone === 'ok',
                        'nok': tile.tone === 'nok',
                        'warn': tile.tone === 'warn',
                        'selected': ExpandedOption === tile.opkey
                    }"
                    (click)="OnToggleOption(tile.opkey)"
                >
                    <span class="tile-icon">
                        <ion-icon [name]="tile.icon"></ion-icon>
                        <ion-icon class="tile-badge" [color]="tile.badgeColor" [name]="tile.badgeName"></ion-icon>
                    </span>
                    <span class="tile-label">{{ tr(tile.labelKey) }}</span>
                </button>
            </div>
            <div class="option-detail" *ngIf="ExpandedTile as detail" uppDataid="guesthome-option-detail">
                <ion-icon [color]="detail.badgeColor" [name]="detail.badgeName"></ion-icon>
                <div class="detail-copy">
                    <strong>{{ tr(detail.titleKey) }}</strong>
                    <span class="small">{{ tr(detail.messageKey, detail.messageArgs) }}</span>
                </div>
            </div>
        </div>

        <ion-item uppDataid="guest-view-menu" color="warning" class="action" lines="none" *ngIf="CanViewMenu" (click)="OnViewMenu()">
            <img slot="start" class="action-icon" src="assets/image/place-menu.png" alt="" />
            <ion-label>
                {{ tr('@place_view_menu_title') }}<br/>
                <span class="small">{{ tr('@place_view_menu_message') }}</span>
            </ion-label>
        </ion-item>

        <ng-container *ngIf="!place.IsExpired">
            <ion-item uppDataid="guesthome-order-button" color="warning" class="action" lines="none" (click)="OnMakeOrder()">
                <img slot="start" class="action-icon" src="assets/image/place-order.png" alt="" />
                <ion-label>
                    {{ tr(OrdersViaQr ? '@place_make_order_title' : '@place_prepare_order_title') }}<br/>
                    <span class="small">{{ tr(OrdersViaQr ? '@place_make_order_message' : '@place_prepare_order_message') }}</span>
                </ion-label>
            </ion-item>

            <ion-item uppDataid="guesthome-pay-button" color="warning" class="action" lines="none" *ngIf="CanPayBill" (click)="OnPayBill()">
                <img slot="start" class="action-icon" src="assets/image/place-bill.png" alt="" />
                <ion-label>
                    {{ tr('@place_pay_bill_title') }}<br/>
                    <span class="small">{{ tr('@place_pay_bill_message') }}</span>
                </ion-label>
            </ion-item>

            <ion-item uppDataid="guesthome-receipt-button" color="warning" class="action" lines="none" *ngIf="CanReceipt" (click)="OnReceipts()">
                <img slot="start" class="action-icon" src="assets/image/place-receipt.png" alt="" />
                <ion-label>
                    {{ tr('@place_receipts_title') }}<br/>
                    <span class="small">{{ tr('@place_receipts_message') }}</span>
                </ion-label>
            </ion-item>

            <ion-item
                uppDataid="guesthome-waiter-button"
                [color]="HasWaiterRequest ? 'medium' : 'warning'"
                class="action"
                [class.pending]="HasWaiterRequest"
                lines="none"
                *ngIf="CanCallWaiter"
                (click)="OnCallWaiter()"
            >
                <img slot="start" class="action-icon" src="assets/image/place-request.png" alt="" />
                <ion-label *ngIf="!HasWaiterRequest">
                    {{ tr('@place_call_waiter_title') }}<br/>
                    <span class="small">{{ tr('@place_call_waiter_message') }}</span>
                </ion-label>
                <ion-label *ngIf="HasWaiterRequest">
                    {{ tr('@place_waiter_requested_title') }}<br/>
                    <span class="small">{{ tr('@place_waiter_requested_message_title') }}</span>
                </ion-label>
            </ion-item>
        </ng-container>

        <div class="menu-spacer"></div>
    </upp-scrollable>

    <upp-guest-order *ngIf="Panel === 'ORDER'"
        [place]="place"
        [ticket]="OrderTicket"
        (Close)="OnOrderClosed($event)"
    ></upp-guest-order>

    <upp-guest-payment *ngIf="Panel === 'PAYMENT' || OnlinePayAlive"
        [hidden]="Panel !== 'PAYMENT'"
        [qrcode]="qrcode"
        (Close)="OnPaymentClosed($event)"
        (OnlinePayChange)="OnOnlinePayChange($event)"
    ></upp-guest-payment>

    <upp-guest-waiter *ngIf="Panel === 'WAITER'"
        [qrcode]="qrcode"
        [onlineWait]="OnlineWait"
        [onlineTickets]="OnlinePayTickets"
        [pendingPayTickets]="WaiterPayTickets"
        (Close)="OnEndWaiter($event)"
    ></upp-guest-waiter>

    <upp-guest-receipt *ngIf="Panel === 'RECEIPT'"
        [qrcode]="qrcode"
        (Close)="OnClosePanel()"
    ></upp-guest-receipt>

    <div class="overlay action-overlay" *ngIf="ShowAction">
        <upp-guest-action
            [qrcode]="qrcode"
            (Close)="OnEndAction()"
        ></upp-guest-action>
    </div>

    <div class="overlay ready-overlay" *ngIf="ShowReady">
        <upp-guest-ready
            [qrcode]="qrcode"
        ></upp-guest-ready>
    </div>

    <ng-container *ngIf="ShowPushDenied">
        <ng-container *ngTemplateOutlet="pushDeniedTpl"></ng-container>
    </ng-container>

    <div class="panel-soon" *ngIf="Panel !== 'MENU' && Panel !== 'ORDER' && Panel !== 'PAYMENT' && Panel !== 'WAITER' && Panel !== 'RECEIPT'" uppDataid="guesthome-panel-soon">
        <p>{{ tr('@guest_panel_soon') }}</p>
        <ion-button uppDataid="guesthome-panel-close" color="warning" (click)="OnClosePanel()">
            {{ tr('@guest_panel_back') }}
        </ion-button>
    </div>
</div>
